export default {
  "hierarchy": {
    "title": [
      "text-title"
    ],
    "subtitle": [
      "text-subtitle"
    ],
    "body": [
      "text-body"
    ],
    "bodySmall": [
      "text-bodySmall"
    ],
    "caption": [
      "text-caption"
    ],
    "captionSmall": [
      "text-captionSmall"
    ],
    "navLogoLabel": [
      "text-subtitle",
      "text-navLogoLabel"
    ],
    "pageTitle": [
      "text-title",
      "text-pageTitle"
    ],
    "sectionTitle": [
      "text-title",
      "text-sectionTitle"
    ],
    "sectionBody": [
      "text-bodySmall",
      "text-sectionBody"
    ],
    "cardTitle": [
      "text-subtitle",
      "text-cardTitle"
    ],
    "formTitle": [
      "text-title",
      "text-formTitle"
    ],
    "formSubtitle": [
      "text-subtitle",
      "text-formSubtitle"
    ],
    "formBody": [
      "text-body",
      "text-formBody"
    ],
    "listItemTitle": [
      "text-subtitle",
      "text-listItemTitle"
    ],
    "listItemSubtitle": [
      "text-caption",
      "text-listItemSubtitle"
    ],
    "inputCaptionSmall": [
      "text-captionSmall",
      "text-inputCaptionSmall"
    ],
    "inputCaptionSmallError": [
      "text-captionSmall",
      "text-inputCaptionSmall",
      "text-inputCaptionSmallError"
    ],
    "loginWarning": [
      "text-bodySmall",
      "text-loginWarning"
    ],
    "mobileMapTitle": [
      "text-bodySmall",
      "text-mobileMapTitle"
    ],
    "mobileTitle": [
      "text-bodySmall",
      "text-mobileTitle"
    ],
    "captionBold": [
      "text-captionBold"
    ],
    "captionSmallBold": [
      "text-captionSmallBold"
    ],
    "toastTitle": [
      "text-subtitle",
      "text-toastTitle"
    ],
    "toastMsg": [
      "text-caption",
      "text-toastMsg"
    ],
    "detailTitle": [
      "text-subtitle",
      "text-detailTitle"
    ],
    "detailLabel": [
      "text-bodySmall",
      "text-detailLabel"
    ],
    "detailValue": [
      "text-bodySmall",
      "text-detailValue"
    ],
    "detailSuffix": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailSuffix"
    ],
    "screenTitle": [
      "text-title",
      "text-screenTitle"
    ],
    "dialogTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle"
    ],
    "sideNav": [
      "text-sideNav"
    ],
    "loginLogo": [
      "text-loginLogo"
    ],
    "listDetailTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-listDetailTitle"
    ],
    "mobileUserNavBar": [
      "text-mobileUserNavBar"
    ],
    "groupTitle": [
      "text-captionSmall",
      "text-groupTitle"
    ],
    "dashboardCardTitle": [
      "text-subtitle",
      "text-dashboardCardTitle"
    ],
    "dashboardCardEditorTitle": [
      "text-subtitle",
      "text-dashboardCardTitle",
      "text-dashboardCardEditorTitle"
    ],
    "rootEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle"
    ],
    "actionBar": [
      "text-actionBar"
    ],
    "sideNavBarHeader": [
      "text-captionBold",
      "text-sideNavBarHeader"
    ],
    "networkOffline": [
      "text-networkOffline"
    ],
    "sideNavSmall": [
      "text-sideNav",
      "text-sideNavSmall"
    ],
    "linearViewHeaderCell1": [
      "text-linearViewHeaderCell1"
    ],
    "linearViewHeaderCell2": [
      "text-linearViewHeaderCell2"
    ],
    "pairingErrorSubtitle": [
      "text-pairingErrorSubtitle"
    ],
    "bodyCentered": [
      "text-bodyCentered"
    ],
    "resendSuccess": [
      "text-resendSuccess"
    ],
    "twoFactorWarning": [
      "text-twoFactorWarning"
    ],
    "pill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill"
    ],
    "pillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary"
    ],
    "pillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess"
    ],
    "pillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning"
    ],
    "pillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError"
    ],
    "resendCodeSuccess": [
      "text-resendCodeSuccess"
    ],
    "twoStepTitle": [
      "text-twoStepTitle"
    ],
    "hint": [
      "text-hint"
    ],
    "columnValue": [
      "text-columnLabel",
      "text-columnValue"
    ],
    "columnLabel": [
      "text-columnLabel"
    ],
    "conditionTitle": [
      "text-bodySmall",
      "text-conditionTitle"
    ],
    "missingRelTitle": [
      "text-missingRelTitle"
    ],
    "expressionParen": [
      "text-expressionParen"
    ],
    "operatingHoursTitle": [
      "text-operatingHoursTitle"
    ],
    "hintSmall": [
      "text-hint",
      "text-hintSmall"
    ],
    "aggregationTitle": [
      "text-bodySmall",
      "text-detailLabel",
      "text-aggregationTitle"
    ],
    "aggregationLabel": [
      "text-aggregationLabel"
    ],
    "aggregationValue": [
      "text-subtitle",
      "text-aggregationValue"
    ],
    "overrideExample": [
      "text-overrideExample"
    ],
    "editorTitle": [
      "text-subtitle",
      "text-editorTitle"
    ],
    "conditionAttributeLabel": [
      "text-conditionAttributeLabel"
    ],
    "info": [
      "text-twoFactorWarning",
      "text-info"
    ],
    "conditionPropertyComparatorValue": [
      "text-conditionPropertyComparatorValue"
    ],
    "comparator": [
      "text-comparator"
    ],
    "tagError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tagError"
    ],
    "captionCurrent": [
      "text-caption",
      "text-captionCurrent"
    ],
    "tableConditionAttributeLabel": [
      "text-tableConditionAttributeLabel"
    ],
    "mobileNavSubtitle": [
      "text-mobileNavSubtitle"
    ],
    "navSecondaryMobileTitle": [
      "text-navSecondaryMobileTitle"
    ],
    "navSecondaryMobileHeader": [
      "text-navSecondaryMobileHeader"
    ],
    "mobileScreenTitle": [
      "text-mobileScreenTitle"
    ],
    "mobileOptNavTitle": [
      "text-mobileOptNavTitle"
    ],
    "mobileNavBarHeader": [
      "text-mobileNavBarHeader"
    ],
    "ruleTrigger": [
      "text-ruleTrigger"
    ],
    "ruleBlockTitle": [
      "text-ruleBlockTitle"
    ],
    "ruleBlockDescription": [
      "text-ruleBlockDescription"
    ],
    "captionLeft": [
      "text-caption",
      "text-captionLeft"
    ],
    "linkTable": [
      "text-linkTable"
    ],
    "pillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus"
    ],
    "pillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood"
    ],
    "pillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert"
    ],
    "value": [
      "text-value"
    ],
    "valueGood": [
      "text-value",
      "text-valueGood"
    ],
    "valueAlert": [
      "text-value",
      "text-valueAlert"
    ],
    "valueOffline": [
      "text-value",
      "text-valueOffline"
    ],
    "valueLowBattery": [
      "text-value",
      "text-valueLowBattery"
    ],
    "dashboardGridCardTitle": [
      "text-subtitle",
      "text-dashboardCardTitle",
      "text-dashboardGridCardTitle"
    ],
    "passwordRequirement": [
      "text-caption",
      "text-passwordRequirement"
    ],
    "passwordRequirementSuccess": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementSuccess"
    ],
    "passwordRequirementError": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementError"
    ],
    "releaseAvailable": [
      "text-releaseAvailable"
    ],
    "openingHoursHeader": [
      "text-openingHoursHeader"
    ],
    "operatingHoursDay": [
      "text-operatingHoursDay"
    ],
    "groupingsCount": [
      "text-groupingsCount"
    ],
    "groupingsCountEmpty": [
      "text-groupingsCount",
      "text-groupingsCountEmpty"
    ],
    "formTitleCenter": [
      "text-title",
      "text-formTitle",
      "text-formTitleCenter"
    ],
    "valueGoodBattery": [
      "text-valueGoodBattery"
    ],
    "arrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue"
    ],
    "ruleTargetName": [
      "text-ruleTargetName"
    ],
    "rulePathSeparator": [
      "text-rulePathSeparator"
    ],
    "attributeTableUnitSuffix": [
      "text-attributeTableUnitSuffix"
    ],
    "selectorColumnValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-selectorColumnValue"
    ],
    "tablePill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-tablePill"
    ],
    "tablePillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-tablePillWarning"
    ],
    "tablePillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-tablePillSuccess"
    ],
    "tableArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-tableArrayValue"
    ],
    "tablePillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary",
      "text-tablePillPrimary"
    ],
    "tablePillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tablePillError"
    ],
    "tablePillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus",
      "text-tablePillStatus"
    ],
    "tablePillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-tablePillGood"
    ],
    "tablePillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert",
      "text-tablePillAlert"
    ],
    "deviceSelectorResults": [
      "text-deviceSelectorResults"
    ],
    "tempUserEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle",
      "text-tempUserEditorTitle"
    ],
    "tempUserShareError": [
      "text-tempUserShareError"
    ],
    "aggregationEnumAggLabel": [
      "text-aggregationLabel",
      "text-aggregationEnumAggLabel"
    ],
    "inputCaption": [
      "text-caption",
      "text-inputCaption"
    ],
    "attributeDetailUnitSuffix": [
      "text-attributeDetailUnitSuffix"
    ],
    "attributePercentEditor": [
      "text-attributePercentEditor"
    ],
    "detailArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-detailArrayValue"
    ],
    "detailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad"
    ],
    "tvCollectionItemTitle": [
      "text-title",
      "text-tvCollectionItemTitle"
    ],
    "tvDetailLabelNoPad": [
      "text-bodySmall",
      "text-detailLabel",
      "text-tvDetailLabelNoPad"
    ],
    "tvDetailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad",
      "text-tvDetailValueNoPad"
    ],
    "deviceCode": [
      "text-title",
      "text-deviceCode"
    ],
    "iconSuccessLarge": [
      "text-iconSuccessLarge"
    ],
    "titleLarge": [
      "text-title",
      "text-titleLarge"
    ],
    "bodyLarge": [
      "text-body",
      "text-bodyLarge"
    ],
    "altLoginMethod": [
      "text-captionSmall",
      "text-altLoginMethod"
    ],
    "altLoginMethodSmall": [
      "text-captionSmall",
      "text-altLoginMethod",
      "text-altLoginMethodSmall"
    ],
    "bodySmallBold": [
      "text-bodySmall",
      "text-bodySmallBold"
    ],
    "qrCodeInstruction": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter",
      "text-qrCodeInstruction"
    ],
    "bodySmallBoldCenter": [
      "text-bodySmall",
      "text-bodySmallBold",
      "text-bodySmallBoldCenter"
    ],
    "userCode": [
      "text-title",
      "text-userCode"
    ],
    "bodySmallCenter": [
      "text-bodySmall",
      "text-bodySmallCenter"
    ],
    "formBodyCenter": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter"
    ],
    "errorTitle": [
      "text-errorTitle"
    ],
    "detailMultiTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-detailMultiTitle"
    ],
    "rsrcImageDetailTitle": [
      "text-title",
      "text-pageTitle",
      "text-rsrcImageDetailTitle"
    ],
    "detailRsrcTitle": [
      "text-detailRsrcTitle"
    ],
    "perPage": [
      "text-perPage"
    ],
    "pillAlertEnabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillAlertEnabled"
    ],
    "pillAlertDisabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlertDisabled"
    ],
    "pillMotion": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillMotion"
    ],
    "pillStationary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillStationary"
    ],
    "pillInactive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-tablePillGood",
      "text-pillInactive"
    ],
    "pillActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive"
    ],
    "pillIncoming": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming"
    ],
    "pillOutgoing": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillOutgoing"
    ],
    "pillTransferPending": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferPending"
    ],
    "pillTransferred": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferred"
    ],
    "pillTransferredRejected": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferredRejected"
    ],
    "tablePillAlertEnabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillAlertEnabled",
      "text-tablePillAlertEnabled"
    ],
    "tablePillAlertDisabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlertDisabled",
      "text-tablePillAlertDisabled"
    ],
    "tablePillIncoming": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-tablePillIncoming"
    ],
    "tablePillOutgoing": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillOutgoing",
      "text-tablePillOutgoing"
    ],
    "tablePillInactive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-tablePillGood",
      "text-pillInactive",
      "text-tablePillInactive"
    ],
    "tablePillActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-tablePillActive"
    ],
    "tablePillTransferPending": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferPending",
      "text-tablePillTransferPending"
    ],
    "tablePillTransferred": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferred",
      "text-tablePillTransferred"
    ],
    "tablePillTransferredRejected": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferredRejected",
      "text-tablePillTransferredRejected"
    ],
    "theftRecoveryInfo": [
      "text-bodySmall",
      "text-theftRecoveryInfo"
    ],
    "theftRecoverySubtitle": [
      "text-subtitle",
      "text-cardTitle",
      "text-theftRecoverySubtitle"
    ],
    "pillTheftEnding": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillTheftEnding"
    ],
    "theftRecoveryPrimaryAlert": [
      "text-tempUserShareError",
      "text-theftRecoveryPrimaryAlert"
    ],
    "loadingMessage": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-loadingMessage"
    ],
    "pillTheftActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillTheftActive"
    ],
    "tablePillTheftActive": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-pillTheftActive",
      "text-tablePillTheftActive"
    ],
    "pillTransferProcessing": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferProcessing"
    ],
    "tablePillTransferProcessing": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferProcessing",
      "text-tablePillTransferProcessing"
    ],
    "tablePillRejectFailed": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferredRejected",
      "text-tablePillTransferredRejected",
      "text-tablePillRejectFailed"
    ],
    "pillTransferFailed": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferredRejected",
      "text-pillTransferFailed"
    ],
    "tablePillTransferFailed": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-pillActive",
      "text-pillIncoming",
      "text-pillTransferredRejected",
      "text-pillTransferFailed",
      "text-tablePillTransferFailed"
    ],
    "valueVehicle": [
      "text-valueVehicle"
    ],
    "tableValueVehicle": [
      "text-valueVehicle",
      "text-tableValueVehicle"
    ],
    "detailValueVehicle": [
      "text-valueVehicle",
      "text-detailValueVehicle"
    ],
    "valueZone": [
      "text-valueZone"
    ],
    "tableValueZone": [
      "text-valueZone",
      "text-tableValueZone"
    ],
    "detailValueZone": [
      "text-valueZone",
      "text-detailValueZone"
    ]
  },
  "props": {
    "default": {
      "iconOpts": null
    },
    "title": {
      "iconOpts": null
    },
    "subtitle": {
      "iconOpts": null
    },
    "body": {
      "iconOpts": null
    },
    "bodySmall": {
      "iconOpts": null
    },
    "caption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "captionSmall": {
      "iconOpts": null
    },
    "navLogoLabel": {
      "iconOpts": null
    },
    "pageTitle": {
      "iconOpts": null
    },
    "sectionTitle": {
      "iconOpts": null
    },
    "sectionBody": {
      "iconOpts": null
    },
    "cardTitle": {
      "iconOpts": null
    },
    "formTitle": {
      "iconOpts": null
    },
    "formSubtitle": {
      "iconOpts": null
    },
    "formBody": {
      "iconOpts": null
    },
    "listItemTitle": {
      "iconOpts": null
    },
    "listItemSubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "inputCaptionSmall": {
      "iconOpts": null
    },
    "inputCaptionSmallError": {
      "iconOpts": null
    },
    "loginWarning": {
      "iconOpts": null
    },
    "mobileMapTitle": {
      "iconOpts": null
    },
    "mobileTitle": {
      "iconOpts": null
    },
    "captionBold": {
      "iconOpts": null
    },
    "captionSmallBold": {
      "iconOpts": null
    },
    "toastTitle": {
      "iconOpts": null
    },
    "toastMsg": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "detailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "detailLabel": {
      "iconOpts": null
    },
    "detailValue": {
      "iconOpts": null
    },
    "detailSuffix": {
      "iconOpts": null
    },
    "screenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-ScreenIconBackground)",
          "borderRadius": "2px",
          "color": "var(--color-ScreenIcon)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "dialogTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "sideNav": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "height": "0px",
        "width": "0px"
      },
      "useEllipsis": true
    },
    "loginLogo": {
      "iconOpts": null,
      "icon": "https://storage.googleapis.com/molten-ui-assets/Customer%20Logos/recovr-dark.svg",
      "imageOpts": {
        "width": "300px"
      }
    },
    "listDetailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "mobileUserNavBar": {
      "iconOpts": null,
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "groupTitle": {
      "iconOpts": null
    },
    "dashboardCardTitle": {
      "iconOpts": null
    },
    "dashboardCardEditorTitle": {
      "iconOpts": null
    },
    "rootEditorTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "actionBar": {
      "iconOpts": null
    },
    "sideNavBarHeader": {
      "iconOpts": null
    },
    "networkOffline": {
      "iconOpts": null
    },
    "sideNavSmall": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "width": "0"
      },
      "useEllipsis": true
    },
    "linearViewHeaderCell1": {
      "iconOpts": null
    },
    "linearViewHeaderCell2": {
      "iconOpts": null
    },
    "pairingErrorSubtitle": {
      "iconOpts": null
    },
    "bodyCentered": {
      "iconOpts": null
    },
    "resendSuccess": {
      "iconOpts": null,
      "icon": "https://molten-ui-assets.storage.googleapis.com/two-step-success.png",
      "imageOpts": {
        "height": "18px",
        "width": "18px"
      }
    },
    "twoFactorWarning": {
      "iconOpts": {
        "style": {
          "color": "#E9354D",
          "fontSize": "18px"
        }
      },
      "icon": "lv lv-system-error"
    },
    "pill": {
      "iconOpts": null
    },
    "pillPrimary": {
      "iconOpts": null
    },
    "pillSuccess": {
      "iconOpts": null
    },
    "pillWarning": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "pillError": {
      "iconOpts": null
    },
    "resendCodeSuccess": {
      "iconOpts": {
        "style": {
          "color": "#15b982",
          "fontSize": "20px"
        }
      },
      "icon": "@icon:success"
    },
    "twoStepTitle": {
      "iconOpts": null
    },
    "hint": {
      "iconOpts": null
    },
    "columnValue": {
      "iconOpts": null
    },
    "columnLabel": {
      "iconOpts": null
    },
    "conditionTitle": {
      "iconOpts": null
    },
    "missingRelTitle": {
      "iconOpts": null
    },
    "expressionParen": {
      "iconOpts": null
    },
    "operatingHoursTitle": {
      "iconOpts": null
    },
    "hintSmall": {
      "iconOpts": null
    },
    "aggregationTitle": {
      "iconOpts": null
    },
    "aggregationLabel": {
      "iconOpts": null
    },
    "aggregationValue": {
      "iconOpts": null
    },
    "overrideExample": {
      "iconOpts": null
    },
    "editorTitle": {
      "iconOpts": null
    },
    "conditionAttributeLabel": {
      "iconOpts": null
    },
    "info": {
      "iconOpts": {
        "style": {
          "color": "#0d49e4",
          "fontSize": "14px"
        }
      },
      "icon": "@icon:info-filled"
    },
    "conditionPropertyComparatorValue": {
      "iconOpts": null
    },
    "comparator": {
      "iconOpts": null
    },
    "tagError": {
      "iconOpts": null
    },
    "captionCurrent": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "tableConditionAttributeLabel": {
      "iconOpts": null
    },
    "mobileNavSubtitle": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "navSecondaryMobileTitle": {
      "iconOpts": null
    },
    "navSecondaryMobileHeader": {
      "iconOpts": null
    },
    "mobileScreenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      }
    },
    "mobileOptNavTitle": {
      "iconOpts": null
    },
    "mobileNavBarHeader": {
      "iconOpts": null
    },
    "ruleTrigger": {
      "iconOpts": null
    },
    "ruleBlockTitle": {
      "iconOpts": {
        "style": {
          "background": "",
          "color": "",
          "fontSize": "16px",
          "padding": ""
        }
      },
      "imageOpts": {
        "width": "24px"
      }
    },
    "ruleBlockDescription": {
      "iconOpts": null
    },
    "captionLeft": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "linkTable": {
      "iconOpts": null
    },
    "pillStatus": {
      "iconOpts": null
    },
    "pillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "value": {
      "iconOpts": null
    },
    "valueGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "valueAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-regular fa-circle-exclamation"
    },
    "valueOffline": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base500)"
        }
      },
      "icon": "fa-solid fa-wifi-slash"
    },
    "valueLowBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-battery-low"
    },
    "dashboardGridCardTitle": {
      "iconOpts": null
    },
    "passwordRequirement": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base200)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-minus"
    },
    "passwordRequirementSuccess": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-check"
    },
    "passwordRequirementError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-close"
    },
    "releaseAvailable": {
      "iconOpts": null
    },
    "openingHoursHeader": {
      "iconOpts": null
    },
    "operatingHoursDay": {
      "iconOpts": null
    },
    "groupingsCount": {
      "iconOpts": null
    },
    "groupingsCountEmpty": {
      "iconOpts": null
    },
    "formTitleCenter": {
      "iconOpts": null
    },
    "valueGoodBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-regular fa-battery-full"
    },
    "arrayValue": {
      "iconOpts": null
    },
    "ruleTargetName": {
      "iconOpts": null
    },
    "rulePathSeparator": {
      "iconOpts": null
    },
    "attributeTableUnitSuffix": {
      "iconOpts": null
    },
    "selectorColumnValue": {
      "iconOpts": null
    },
    "tablePill": {
      "iconOpts": null
    },
    "tablePillWarning": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "tablePillSuccess": {
      "iconOpts": null
    },
    "tableArrayValue": {
      "iconOpts": null
    },
    "tablePillPrimary": {
      "iconOpts": null
    },
    "tablePillError": {
      "iconOpts": null
    },
    "tablePillStatus": {
      "iconOpts": null
    },
    "tablePillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "deviceSelectorResults": {
      "iconOpts": null
    },
    "tempUserEditorTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "32"
      }
    },
    "tempUserShareError": {
      "iconOpts": {
        "style": {
          "color": "var( --color-danger500 )",
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "aggregationEnumAggLabel": {
      "iconOpts": null
    },
    "inputCaption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "attributeDetailUnitSuffix": {
      "iconOpts": null
    },
    "attributePercentEditor": {
      "iconOpts": null
    },
    "detailArrayValue": {
      "iconOpts": null
    },
    "detailValueNoPad": {
      "iconOpts": null
    },
    "tvCollectionItemTitle": {
      "iconOpts": null
    },
    "tvDetailLabelNoPad": {
      "iconOpts": null
    },
    "tvDetailValueNoPad": {
      "iconOpts": null
    },
    "deviceCode": {
      "iconOpts": null
    },
    "iconSuccessLarge": {
      "iconOpts": null
    },
    "titleLarge": {
      "iconOpts": null
    },
    "bodyLarge": {
      "iconOpts": null
    },
    "altLoginMethod": {
      "iconOpts": null
    },
    "altLoginMethodSmall": {
      "iconOpts": null
    },
    "bodySmallBold": {
      "iconOpts": null
    },
    "qrCodeInstruction": {
      "iconOpts": null
    },
    "bodySmallBoldCenter": {
      "iconOpts": null
    },
    "userCode": {
      "iconOpts": null
    },
    "bodySmallCenter": {
      "iconOpts": null
    },
    "formBodyCenter": {
      "iconOpts": null
    },
    "errorTitle": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "detailMultiTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "rsrcImageDetailTitle": {
      "iconOpts": null
    },
    "detailRsrcTitle": {
      "iconOpts": null
    },
    "perPage": {
      "iconOpts": null
    },
    "pillAlertEnabled": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-sharp fa-solid fa-bell"
    },
    "pillAlertDisabled": {
      "iconOpts": null,
      "icon": "fa-solid fa-bell-slash"
    },
    "pillMotion": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-kit fa-lv-in-motion"
    },
    "pillStationary": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa fa-fw fa-solid fa-location-check"
    },
    "pillInactive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillIncoming": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-arrow-left"
    },
    "pillOutgoing": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "icon": "fa-solid fa-arrow-right"
    },
    "pillTransferPending": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning700)"
        }
      },
      "icon": "fa-regular fa-clock-three"
    },
    "pillTransferred": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillTransferredRejected": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "icon": "fa-solid fa-circle-xmark"
    },
    "tablePillAlertEnabled": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-sharp fa-solid fa-bell"
    },
    "tablePillAlertDisabled": {
      "iconOpts": null,
      "icon": "fa-solid fa-bell-slash"
    },
    "tablePillIncoming": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-arrow-left"
    },
    "tablePillOutgoing": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "icon": "fa-solid fa-arrow-right"
    },
    "tablePillInactive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillTransferPending": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning700)"
        }
      },
      "icon": "fa-regular fa-clock-three"
    },
    "tablePillTransferred": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillTransferredRejected": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base700)"
        }
      },
      "icon": "fa-solid fa-circle-xmark"
    },
    "theftRecoveryInfo": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)",
          "fontSize": "18px"
        }
      },
      "icon": "fa fa-info-circle"
    },
    "theftRecoverySubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "pillTheftEnding": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-theft-shield"
    },
    "theftRecoveryPrimaryAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)",
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "loadingMessage": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "pillTheftActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger900)",
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-theft-shield"
    },
    "tablePillTheftActive": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger900)",
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-theft-shield"
    },
    "pillTransferProcessing": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "icon": "fa-kit fa-loading"
    },
    "tablePillTransferProcessing": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "icon": "fa-kit fa-loading"
    },
    "tablePillRejectFailed": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "pillTransferFailed": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "tablePillTransferFailed": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "valueVehicle": {
      "iconOpts": null,
      "icon": "fa-solid fa-car"
    },
    "tableValueVehicle": {
      "iconOpts": null,
      "icon": "fa-solid fa-car"
    },
    "detailValueVehicle": {
      "iconOpts": null,
      "icon": "fa-solid fa-car"
    },
    "valueZone": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-map-zone-geofence"
    },
    "tableValueZone": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-map-zone-geofence"
    },
    "detailValueZone": {
      "iconOpts": null,
      "icon": "fa-kit fa-lv-map-zone-geofence"
    }
  }
}